export const mergeDetectedStructuredData = (current = {}, detected = {}) => {
    const detectedData = detected || {};

    return Object.keys(current).reduce((next, key) => {
        if (Object.prototype.hasOwnProperty.call(detectedData, key)) {
            next[key] = detectedData[key];
        }
        return next;
    }, { ...current });
};
